module.exports = __webpack_public_path__ + "media/images/new_home/down-arrow-69f9da4a977f54879dea166dc9119292.png";